import { render, staticRenderFns } from "./ExerciseImgVideo.vue?vue&type=template&id=36a5d519&scoped=true"
import script from "./ExerciseImgVideo.vue?vue&type=script&lang=js"
export * from "./ExerciseImgVideo.vue?vue&type=script&lang=js"
import style0 from "./ExerciseImgVideo.vue?vue&type=style&index=0&id=36a5d519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a5d519",
  null
  
)

export default component.exports